import { render, staticRenderFns } from "./LessonMeeting.vue?vue&type=template&id=bb8b2bb0&"
import script from "./LessonMeeting.vue?vue&type=script&lang=js&"
export * from "./LessonMeeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports